import { render } from "./Header.vue?vue&type=template&id=3fe16072&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3fe16072"

export default script